import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.REPORTING}/`;

export const GetReportHistoryAPI = ({ onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}history`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DownloadReportAPI = async ({
  executionId,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}download/${executionId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType: 'blob',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
